module.exports = __webpack_public_path__ + "static/img/logo.1b5dd601.png";